module.exports = __webpack_public_path__ + "static/media/icon-compare.4f78e370.svg";